module.exports = __webpack_public_path__ + "static/media/image_39.cd27a1bd.png";